export class Thread {

  static async doEvents(): Promise<void> {
    await Promise.resolve();
  }

  static async sleep(milliseconds: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, milliseconds));
  }
}
